/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'SHOW_NAVIGATION',
  'HIDE_NAVIGATION',
  'SET_EVENT_SCREEN_NAME',
]);



// WEBPACK FOOTER //
// ./src/rsvp/constants/PaymentHeaderConstants.js